import { Injector } from '@angular/core';
import { subtractPoints } from '../../../../../shared/misc-utilities/point-utils';
import { Point2D } from '../../../../../team-apis/otterdam/answers/shape-typings';
import { AbstractDragHandler2D } from './abstract-drag-handler-2d';
import { AbstractVectorTranslationHelper } from './abstract-vector-translation-helper';

export class VectorDragHandler extends AbstractDragHandler2D {
  protected override ignoreNonDrags: boolean;
  protected override shouldTrackBatchEvents = true;
  private restrictInteractions: boolean;
  private releaseRestrictedInteractions?: VoidFunction;

  private initialImagePoint = this.getImagePoint();

  constructor(
    initialEvent: MouseEvent,
    injector: Injector,
    protected translationHelper: AbstractVectorTranslationHelper,
    { ignoreNonDrags = true, restrictInteractions = false } = {},
  ) {
    super(initialEvent, injector);
    this.event = translationHelper.event;
    this.ignoreNonDrags = ignoreNonDrags;
    this.restrictInteractions = restrictInteractions;
  }

  protected onDrag(dragPoint: Point2D) {
    if (this.restrictInteractions && !this.releaseRestrictedInteractions) {
      this.releaseRestrictedInteractions =
        this.shellConnector.restrictInteractions('canvas');
    }
    const delta = subtractPoints(dragPoint, this.initialImagePoint);
    this.translationHelper.move(delta);
  }

  protected override complete() {
    this.translationHelper.pushAndTrackEvent({
      ...this.batchValues?.buildEventTrackingValue(),
      source: 'edit_tool',
    });
  }

  protected override cleanUp() {
    super.cleanUp();

    if (this.releaseRestrictedInteractions) {
      this.releaseRestrictedInteractions();
      this.releaseRestrictedInteractions = undefined;
    }
  }
}
